module.exports = __webpack_public_path__ + "static/img/A179.aa525400.jpg";